export const environment = {
    production: false,
    isExternal: true,
    msalConfig: {
        auth: {
            clientId: '0a9cb639-ca3a-410f-aebd-2b2692420c18',
            authority: ""
        },
    },
    apiConfig: {
        scopes: ['openid profile offline_access 0a9cb639-ca3a-410f-aebd-2b2692420c18'],
        uri: 'https://pplfirstclassicdev.onmicrosoft.com/0a9cb639-ca3a-410f-aebd-2b2692420c18/app.user',
    },
    b2cPolicies: {
        names: {
            signUpSignIn: 'B2C_1A_TST_SIGNUP_SIGNIN',
        },
        authorities: {
            signUpSignIn: {
                authority:
                    'https://pplfirstclassicdev.b2clogin.com/pplfirstclassicdev.onmicrosoft.com/B2C_1A_TST_SIGNUP_SIGNIN',
            }
        },
        authorityDomain: 'pplfirstclassicdev.b2clogin.com',
    },
    apiUrl: 'https://ngencl-api-tst.pplfirst.com/external-cl',
    mobileHealthUrl: 'https://www.mobilehealth.com/ny-cdpap-ppl-medical-screenings/',
    wotcUrl: 'https://sandbox.wotc.com/portal/public-partnerships-llc-sandbox/f8850?noStartDate=1',
    apimSubScriptionKey: '9cea3b8d4ce44d67adbb8a04c5129187',
    smartyEmbeddedKey: '215669382422753323',
    isSmartyEnabled: true,
    enableCaliforniaAddressValidation: true,
    restrictedMenus: ["process_codes", "service_codes", "participant_provider_rates", "authorizations", "timesheets"],
    requireAtleastOneUserFilter: true,
    goLiveDate: '2026-07-01',
    showGoLiveBanner: false
};